import(/* webpackMode: "eager" */ "/app/packages/schoolfeed/app/error.jsx");
